export const getFieldLabel = () => {
  const domain = window.location.hostname;
  switch (domain) {
    case "ep.maot.co.kr":
      return "작업장명";
    case "nhsafe.maot.co.kr":
      return "현장명";
    default:
      return "사업장명";
  }
};
